module.exports = __webpack_public_path__ + "img/d15.d3caf0b4.png";